import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'

import { Spinner } from '@vp/swan'
import { initCA } from '@vp/chat-anywhere'
import VistaprintAuth from '@vp/auth'

import ChatContent from './LegacyChatContent'
import DisabledLiveChat from './DisabledLegacyLiveChat'
import { useBannerStatusContext } from '../../contexts/StatusContext'
import chatHelper from '../../helpers/chatHelper'
import useStatusChecker from '../../hooks/useStatusChecker'
import AuthProvider from '../../modules/auth/authProvider'
import ChatService from '../../services/chat/chatService'
import AnalyticsTracking from '../analytics/analytics'
import { useConfig } from '../../contexts/ConfigProvider'

const LegacyLiveChat = (props) => {
  const { locale, isProadvantage, tenant, trackingTenant, t } = props
  const [buttonId, setButtonId] = useState('')
  const [statusLoading, setStatusLoading] = useState(true)
  const [chatEnabled, setChatEnabled] = useState(true)
  const [ttl, setTtl] = useState(0)
  const [remainingTime, setRemainingTime] = useState(0)
  const [timeout, setDelay] = useState(null)
  const [timer, setTimer] = useState(null)

  const lng = locale.toLowerCase().replace('-', '_')
  const { initialData } = useBannerStatusContext()
  const { data: status, isLoading: loading } = useStatusChecker(tenant, locale, initialData)
  const dataConfig = useConfig()
  const chatInit = async () => {
    const chatService = new ChatService()
    if (chatHelper.isCAEnabled(locale)) initCA()

    const config = AuthProvider.initAuthConfig()
    await VistaprintAuth.init(config, async (identity) => {
      const authLibrary = new VistaprintAuth.WebAuth()
      if (authLibrary && authLibrary.getIdentity()) {
        const chat = await chatService.getChat(tenant, locale, isProadvantage ? 'ProAdvantageChat' : 'ContactUsPage', undefined, dataConfig)
        const gcpChatEnabled = chat.status.isChatEnabled
        const chatTTL = chat.status.TTL
        const chatRemainingTime = chat.status.remainingTime
        const chatButtonId = chat.parameters.buttonId
        let userId = ''
        const trackingUserId = window.localStorage.getItem('ajs_user_id') || ''
        const anonymousId = authLibrary.getCanonicalId()
        if (authLibrary.getIdentity().isSignedIn === 1) {
          userId = authLibrary.getIdentity().profile['https://claims.cimpress.io/canonical_id']
        }

        if (chat && chat.status && chat.parameters) {
          setButtonId(chatButtonId)
          setChatEnabled(gcpChatEnabled)
          setTtl(chatTTL)
          setRemainingTime(chatRemainingTime)

          if (
            chat.parameters.buttonId &&
            chat.parameters.deploymentId &&
            chat.parameters.organizationId &&
            chat.parameters.deploymentScriptUrl &&
            chat.parameters.baseLiveAgentURL
          ) {
            const s = window.document.createElement('script')
            s.setAttribute('src', `${chat.parameters.deploymentScriptUrl}`)

            s.onload = function () {
              const getCookieValue = (cookieName) => {
                try {
                  const theCookie = ' ' + document.cookie
                  let ind = theCookie.indexOf(' ' + cookieName + '=')
                  if (ind === -1) ind = theCookie.indexOf(';' + cookieName + '=')
                  if (ind === -1 || cookieName === '') return ''
                  let ind1 = theCookie.indexOf(';', ind + 1)
                  if (ind1 === -1) ind1 = theCookie.length

                  return unescape(theCookie.substring(ind + cookieName.length + 2, ind1))
                } catch (e) {
                  console.log('Error in fetching Cookie', e)
                }
              }

              const optimizelyEndUserId = getCookieValue('optimizelyEndUserId')

              AnalyticsTracking.getSegmentKey(tenant, locale).then(function (segmentKey) {
                window.liveagent.addCustomDetail('segment_write_key', segmentKey)
                window.liveagent.addCustomDetail('segment_user_id', userId)
                window.liveagent.addCustomDetail('segment_tracking_user_id', trackingUserId)
                window.liveagent.addCustomDetail('segment_anonymous_id', anonymousId)
                window.liveagent.addCustomDetail('segment_language_locale', locale)
                window.liveagent.addCustomDetail('segment_language', locale.split('-')[0])
                window.liveagent.addCustomDetail('segment_locale', locale.split('-')[1])
                window.liveagent.addCustomDetail('segment_tracking_tenant', trackingTenant)
                const visit = window?.tracking?.visit() || undefined
                if (visit) {
                  window.liveagent.addCustomDetail('segment_visit', visit)
                }
                window.liveagent.addCustomDetail('segment_fiscal_year', AnalyticsTracking.getFiscalYear(new Date()))
                window.liveagent.addCustomDetail('segment_page_name', 'Home Page:Help Center')
                window.liveagent.addCustomDetail('segment_page_section', 'Help Center')
                window.liveagent.addCustomDetail('segment_page_stage', 'Customer Care')
                window.liveagent.addCustomDetail('segment_gen_track', 'Titans Squad')
                window.liveagent.addCustomDetail('segment_optimizely_end_userid', optimizelyEndUserId)
              })

              window.liveagent.init(`${chat.parameters.baseLiveAgentURL}`, `${chat.parameters.deploymentId}`, `${chat.parameters.organizationId}`)
            }
            window.document.body.appendChild(s)

            if (!window._laq) {
              // this can result in having the same below functions multiple times in the array.
              window._laq = []
            }

            /* //Hide loading components when chat is online
                        var observer_online = new MutationObserver(function (mutations) {
                            mutations.forEach(function (mutationRecord) {
                                window.document.getElementById(`liveagent_prefooter_chat_box_sep`).style = 'display: none;';
                                window.document.getElementById(`liveagent_prefooter_chat_box_sep2`).style = 'display: block;';
                                window.document.getElementById(`liveagent_prefooter_chat_box`).style = 'display: block;';
                                window.document.getElementById(`liveagent_prefooter_link_loading`).style = 'display: none;';
                                window.document.getElementById(`liveagent_prefooter_subtitle_loading`).style = 'display: none;';
                            });
                        });
                        var target_online = window.document.getElementById(`liveagent_button_online`);
                        observer_online.observe(target_online, { attributes: true, attributeFilter: ['style'] });

                        //Hide loading components when chat is offline
                        var observer_offline = new MutationObserver(function (mutations) {
                            mutations.forEach(function (mutationRecord) {
                                window.document.getElementById(`liveagent_prefooter_chat_box_sep`).style = 'display: none;';
                                window.document.getElementById(`liveagent_prefooter_chat_box_sep2`).style = 'display: block;';
                                window.document.getElementById(`liveagent_prefooter_chat_box`).style = 'display: block;';
                                window.document.getElementById(`liveagent_prefooter_link_loading`).style = 'display: none;';
                                window.document.getElementById(`liveagent_prefooter_subtitle_loading`).style = 'display: none;';
                            });
                        });
                        var target_offline = window.document.getElementById(`liveagent_button_offline`);
                        observer_offline.observe(target_offline, { attributes: true, attributeFilter: ['style'] }); */

            // this function is being called by the deployment script
            // if this is going to be removed you need to be sure that the chat buttons change state whenever the chat is online or offline
            // since showWhenOnline & showWhenOffline functions are being called by liveagent scripts whenever there's a state change
            window._laq.push(function () {
              // chat preloader
              if (window.document.getElementById('chat_preloader')) {
                window.document.getElementById('chat_preloader').style.display = 'none'
              }
              if (window.document.getElementById('salesforceChatStatusDiv')) {
                window.document.getElementById('salesforceChatStatusDiv').style.display = gcpChatEnabled ? 'flex' : 'none'
              }
              if (window.document.getElementById('forcedOfflineStatus')) {
                window.document.getElementById('forcedOfflineStatus').style.display = !gcpChatEnabled ? 'flex' : 'none'
              }
              if (window.document.getElementById('salesforceChatButtonDiv')) {
                window.document.getElementById('salesforceChatButtonDiv').style.display = gcpChatEnabled ? 'block' : 'none'
              }
              if (window.document.getElementById('forcedOfflineButton')) {
                window.document.getElementById('forcedOfflineButton').style.display = !gcpChatEnabled ? 'block' : 'none'
              }
              if (window.document.getElementById('salesforceChatDescriptionDiv')) {
                window.document.getElementById('salesforceChatDescriptionDiv').style.display = gcpChatEnabled ? 'block' : 'none'
              }
              if (window.document.getElementById('forcedOfflineDescription')) {
                window.document.getElementById('forcedOfflineDescription').style.display = !gcpChatEnabled ? 'block' : 'none'
              }

              if (gcpChatEnabled) {
                // online
                window.liveagent.showWhenOnline(`${chat.parameters.buttonId}`, window.document.getElementById('liveagent_icon_online'))
                window.liveagent.showWhenOnline(`${chat.parameters.buttonId}`, window.document.getElementById('liveagent_title_online'))
                window.liveagent.showWhenOnline(`${chat.parameters.buttonId}`, window.document.getElementById('liveagent_description_online'))
                // offline
                window.liveagent.showWhenOffline(`${chat.parameters.buttonId}`, window.document.getElementById('liveagent_icon_offline'))
                window.liveagent.showWhenOffline(`${chat.parameters.buttonId}`, window.document.getElementById('liveagent_title_offline'))
                window.liveagent.showWhenOffline(`${chat.parameters.buttonId}`, window.document.getElementById('liveagent_button_offline'))
                window.liveagent.showWhenOffline(`${chat.parameters.buttonId}`, window.document.getElementById('liveagent_description_offline'))
                // When CA is enabled showing online button manually
                if (chatHelper.isCAEnabled(locale)) window.document.getElementById('liveagent_button_online').style.display = 'block'
                else window.liveagent.showWhenOnline(`${chat.parameters.buttonId}`, window.document.getElementById('liveagent_button_online'))
              }

              // online
              // window.liveagent.showWhenOnline(`${chat.parameters.buttonId}`, window.document.getElementById(`liveagent_prefooter_subtitle_online`));
              // window.liveagent.showWhenOnline(`${chat.parameters.buttonId}`, window.document.getElementById(`liveagent_prefooter_link_online`));

              // offline
              // window.liveagent.showWhenOffline(`${chat.parameters.buttonId}`, window.document.getElementById(`liveagent_prefooter_subtitle_offline`));
              // window.liveagent.showWhenOffline(`${chat.parameters.buttonId}`, window.document.getElementById(`liveagent_prefooter_link_offline`));

              // window size
              window.liveagent.setChatWindowHeight(685)
              window.liveagent.setChatWindowWidth(500)
            })
          }
        }
        // To be discussed:
        // if chat component is going to be refactored to move away from the deployment script
        // this part of the code should be re-evaluated and probably should be taken care of by the CA Team
        // instead of it being handled by the chat component
        // to be noted:
        // this relies on state changes of ttl and remainingTime but doing it inside this function
        // doesn't make any sense because for this function the states are always the same (applies for class components)
        // A better solution for this should implemented in case we're going to keep it
        if (chatTTL > 0 && chatRemainingTime > 0) {
          const timeout = setTimeout(
            () => {
              chatHelper.updateChat(
                chat,
                chatService,
                chatTTL < chatRemainingTime,
                {
                  setState,
                  props: {
                    tenant,
                    locale,
                  },
                  state: {
                    buttonId: chatButtonId,
                    chatEnabled: gcpChatEnabled,
                    ttl: chatTTL,
                    remainingTime: chatRemainingTime,
                  },
                },
                undefined,
                dataConfig,
              )
              const timerInterval = setInterval(
                chatHelper.updateChat,
                Math.min(chatRemainingTime, chatTTL) * 1000,
                chat,
                chatService,
                chatTTL < chatRemainingTime,
                {
                  setState,
                  props: {
                    tenant,
                    locale,
                  },
                  state: {
                    buttonId: chatButtonId,
                    chatEnabled: gcpChatEnabled,
                    ttl: chatTTL,
                    remainingTime: chatRemainingTime,
                  },
                },
                undefined,
                dataConfig,
              )
              setTimer(timerInterval)
            },
            Math.min(chatRemainingTime, chatTTL) * 1000,
          )
          setDelay(timeout)
        }
      }
    })
  }

  const startChat = () => {
    if (chatHelper.isCAEnabled(locale)) {
      if (!window.$Lightning) {
        window.document.getElementById('liveagent_button_online').style.display = 'none'
        window.document.getElementById('ca_liveagent_button_loading').style.display = 'block'
        window.isChatNowClicked = true
      }
      const EVENT_NAME = 'initCAfromExternalSource'
      const data = {
        eventName: EVENT_NAME,
        timestamp: Date.now(),
        button: 'help-center-chat-now',
      }
      document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: data }))
    } else {
      window.liveagent.startChat(`${buttonId}`)
    }

    AnalyticsTracking.trackEventWithDetails('Chat Initiated', {
      category: 'Global Chat',
      label: 'Chat help initiated',
      pageName: 'Home Page:Help Center',
      pageSection: 'Help Center',
      pageStage: 'Customer Care',
    })
  }

  const setState = (newState) => {
    setButtonId(newState.buttonId || buttonId)
    setStatusLoading(newState.statusLoading !== undefined ? newState.statusLoading : statusLoading)
    setChatEnabled(newState.chatEnabled !== undefined ? newState.chatEnabled : chatEnabled)
    setTtl(newState.ttl || ttl)
    setRemainingTime(newState.remainingTime || remainingTime)
  }

  useEffect(() => {
    if (!loading && (!status?.enabled || !status?.config?.chatDisabled)) chatInit()
    return () => {
      if (timeout) clearTimeout(timeout)
      if (timer) clearInterval(timer)
    }
  }, [isProadvantage, loading])

  if (loading) {
    return (
      <Spinner
        mt={{ lg: '7', md: '7', sm: '6', xs: '6' }}
        style={{ width: '100%' }}
        accessibleText={t(`${tenant}:search_results.preloader_accessibility_label`, { lng })}
        size="standard"
      />
    )
  }

  if (status?.enabled && status?.config?.chatDisabled) return <DisabledLiveChat {...props} />

  return <ChatContent changeLoadingState={setState} t={t} tenant={tenant} locale={locale} chatEnabled={chatEnabled} buttonId={buttonId} startChat={startChat} />
}

export default withTranslation()(LegacyLiveChat)
